import React, { useState, useRef } from "react";
import "./style.scss";

type Props = {
  isAllowed: boolean;
  data: string;
  updateData: (val: string) => void;
};

export const ProfileGender: React.FC<Props> = ({
  isAllowed,
  data,
  updateData,
}) => {
  return (
    <div className="profile-gender-container">
      <span className="profile-gender-title">Gender</span>
      <div className="profile-gender-radio" onClick={() => updateData("Male")}>
        <input
          type="radio"
          checked={data == "Male" ? true : false}
          disabled={!isAllowed}
          onChange={() => {}}
        />
        <span>Male</span>
      </div>
      <div
        className="profile-gender-radio"
        onClick={() => updateData("Female")}
      >
        <input
          type="radio"
          checked={data == "Female" ? true : false}
          disabled={!isAllowed}
          onChange={() => {}}
        />
        <span>Female</span>
      </div>
      <div
        className="profile-gender-radio"
        onClick={() => updateData("Not specified")}
      >
        <input
          type="radio"
          checked={data === "Not specified" ? true : false}
          disabled={!isAllowed}
          onChange={() => {}}
        />
        <span>Not specified</span>
      </div>
    </div>
  );
};
